<div class="lang-select">
  <mat-form-field appearance="outline" class="wm-select wm-select--reverse" [ngClass]="{ 'wm-select--no-border': (isMobile$ | async) === false }">
    <mat-select (selectionChange)="onChangeLanguage($event.value)" [value]="selectedLang" panelClass="wm-select-panelClass wm-select-panelClass--reverse">
      <mat-option *ngFor="let lang of langs" [value]="lang.code">
        {{ lang.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
